<template>
    <div class="myfooter">

      <b-container class="bv-example-row">
        <b-row>
          <b-col><router-link to="/about">关于星空笔记</router-link></b-col>
          <b-col><a target="_blank" href="https://steemitwallet.com">网页钱包</a></b-col>
          <b-col><a target="_blank" href="https://github.com/starnote/starnote.github.io">Github</a></b-col>
          <b-col><a target="_blank" href="https://github.com/steemit/steem-js/tree/master/doc#install">开发手册</a></b-col>
        </b-row>
        <b-row>
          <b-col><router-link to="/newbie">新手指南</router-link></b-col>
          <b-col><a target="_blank" href="https://github.com/aaroncox/vessel/releases">桌面钱包</a></b-col>
          <b-col><a target="_blank" href="https://github.com/steem-driver/awesome-steem">AwesomeSteem</a></b-col>
          <b-col><a target="_blank" href="https://smt.steem.com">SMTs</a></b-col>
        </b-row>
        <b-row>
          <b-col><a target="_blank" href="https://steemh.org">Steem指南</a></b-col>
          <b-col><a target="_blank" :href="'https://steemd.com/@'+this.$store.state.username">区块数据</a></b-col>
          <b-col><a target="_blank" href="https://steemprojects.com">SteemProjects</a></b-col>
          <b-col></b-col>
        </b-row>

      </b-container>
      <p class="info">Copyright©2019　 星空笔记，基于Steem和IPFS的区块链笔记　@lemooljiang创建 　QQ:497867999</p>


      </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

  .myfooter{
    background-color: rgba(29,32,136,0.93);
    color: gainsboro;
    width: 100%;
    height: 7.2rem;
    padding-top: 1rem;
    padding-left: 3rem;
    padding-right: 3rem;
    position:absolute;
    bottom:0px;
    font-size: 0.8rem;
  }
  .router-link-exact-active{
    color: aqua !important;
    border-bottom: 1px solid rgba(29,32,136,0.93);
    text-align: center;
  }
  .bv-example-row{
    align: left;
    float:left;
  }
  .info{
    margin-left: 0.8rem;
    margin-top: 4rem;
  }

  a{
    color: gainsboro;
    margin-right: 0.4rem;
    margin-left: 0.4rem;
  }

  a:hover{
    color: aqua;
    text-decoration: none;
  }
</style>
